
$(function(){
    $('.js-modal-popup').on('click', function(){

        if($(this).attr('data-image') != null){
            $("#js-modal-image").removeClass('d-none').attr('src', $(this).attr('data-image'));
            $("#js-modal-video-wrapper").addClass('d-none');
        }else{
            let id = $(this).attr('data-video');
            $("#js-modal-image").addClass('d-none');
            $("#js-modal-video-wrapper").removeClass('d-none');


            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            document.body.appendChild(tag);

            document.body.tabIndex = 1;

            new YT.Player('js-modal-video', {
                videoId: id,
                playerVars: {
                    cc_load_policy: 0,
                    allowFullscreen: true,
                    autoplay: 0,
                    origin: 'https://' + window.location.hostname,
                    enablejsapi: 1,
                    modestBranding: 1,
                    rel: 0,
                    showinfo: 0,
                }
            });

            document.body.tabIndex = 1;
            window.setInterval(function(){
                if(document.activeElement.tagName == "IFRAME") {
                    document.body.focus();
                }
            }, 250);
        }

        $("#js-modal-title").html($(this).attr('data-title'));
        $("#js-modal-content").html($(this).attr('data-content'));
        $('#js-modal-toggle').trigger('click');
    });

    $('#js-modal-popup').on('hide.bs.modal', function (e) {
        $("#js-modal-video-wrapper").empty().append('<div id="js-modal-video" class="video-frame"></div>');
    });
})
